export const defaultAvatarColors = [
  // Used in automatic color selection for avatars and other entities
  'blue',
  'orange',
  'green',
  'red',
  'mint',
  'purple',
  'crimson',
  'brown',
  'gray',
] as const
export const otherAvatarColors = ['white', 'blue200', 'blue400'] as const
export const allAvatarColors = [...defaultAvatarColors, ...otherAvatarColors] as const
export type DefaultAvatarColors = (typeof defaultAvatarColors)[number]
export type AllAvatarColors = (typeof allAvatarColors)[number]
